let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6QVYs")).then(() => parcelRequire('9rAua'));